import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

import Button from '../../Button';

const TableButton = ({ children, className, ...props }) => {
  const { classes, cx } = useStyles(styles);

  return (
    <Button className={cx(classes.tableButton, className)} {...props}>
      {children}
    </Button>
  );
};

const styles = ({ spacing }) => ({
  tableButton: {
    border: 'none',
    padding: spacing(1),
    minWidth: 36,
    marginLeft: spacing(0.5),
    height: 36,
    '&:first-child': {
      marginLeft: 0,
    },
  },
});

TableButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default TableButton;
